import axios from 'axios'; // Assuming Axios for HTTP requests
import { format, parseISO } from 'date-fns';
import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useParams, useNavigate, Link, useSearchParams  } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import '../assets/css/PollView.css';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';
import defaultImage from "../assets/image/demo.jpeg";

const MemberForm = () => {
    const [searchParams] = useSearchParams();
    const [historyData, setHistoryData] = useState([]);
    const roleid = parseInt(sessionStorage.getItem("userroleId"));
    const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
    const username = sessionStorage.getItem("username");
    const token = sessionStorage.getItem("token"); // Retrieve token
    const [transData, setTransData] = useState([]);
    const [joiningDate, setJoiningDate] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [lastRenewal, setLastReneal] = useState('');
    const [membersTerm, setMembersTerm] = useState('');
    const [sameAsPresent, setSameAsPresent] = useState('');
    const [selectedTerm, setSelectedTerm] = useState("");
    const [chapterID, setChapterID] = useState("");
    const [options, setOptions] = useState([]); 
    const location = useLocation();
    const navigate = useNavigate();
    const [chapters, setChapters] = useState([]);
    const [chapterAdmin, setChapterAdmin] = useState("");
    const queryParams = new URLSearchParams(location.search);
    // const edit = queryParams.get('edit') === 'true';
    const memberId = searchParams.get("memberId");
    const edit = searchParams.get("edit") === "true";
    // console.log('member:',memberId)
    const [isEditing, setIsEditing] = useState(edit);
    const [profilePic, setProfilePic] = useState();
    const [profilePicFile, setProfilePicFile] = useState(null); // real File to upload
    const originalSnapshot = useRef(null);
    const userChangedTermOrDate = useRef(false); 
    const [hasChanges, setHasChanges] = useState(false);
    // Function to format date to YYYY-MM-DD
    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = parseISO(dateStr);
        return format(date, 'yyyy-MM-dd'); // Formats to YYYY-MM-DD
    };

    // Fetch chapters from DB on mount
    useEffect(() => {
        const fetchChapters = async () => {
            try {
                const response = await fetch(`${baseurl}/admin/chapters`, {
                    headers: { Authorization: `${token}` }
                });
                const data = await response.json();
                setChapters(data);
            } catch (error) {
                console.error('Failed to fetch chapters:', error);
            }
        };
        fetchChapters();
    }, []);

    const normalize = (val) => String(val ?? '').trim().toLowerCase();

    // const isChanged = (current, previous, field) => {
    //     if (!previous) return false; // first/oldest entry — nothing to compare against
    //     return normalize(current[field]) !== normalize(previous[field]);
    // };

    const changedCellStyle = {
        backgroundColor: 'var(--bs-danger-bg-subtle, #fff5f5)',
        color: '#c0392b',
        fontWeight: '500',
    };

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        gender: '',
        dob: '',
        mobileNumber: '',
        membership_no: '',
        email: '',
        joiningDate: '',
        expiryDate: '',
        lastRenewal: '',
        membersTerm: '',
        presentAddress: {
            address: '',
            city: '',
            state: '',
            pincode: '',
        },
        permanentAddress: {
            address: '',
            city: '',
            state: '',
            pincode: '',
        },
        sameAsPresent: '',
        testDate: '',
        firstTestScore: '',
        firstTestName: '',
        secondTestScore: '',
        secondTestName: '',
        note: '',
        profilePic:'',
    });

    const exportToPDF = () => {
        if (historyData.length === 0) {
            alert("No data to export!");
            return;
        }

        const doc = new jsPDF();
        doc.text("Member History Report", 14, 10);

        const tableColumn = ["Date", "First Name", "Last Name", "Mobile No", "Email ID", "Address", "Edited By"];
        const tableRows = historyData.map(entry => [
            formatDate(entry.timestamp),
            entry.first_name,
            entry.last_name,
            entry.mobile_no,
            entry.email,
            `${entry.present_address}, ${entry.present_city}, ${entry.present_state} - ${entry.present_pincode}`,
            entry.edited_by
        ]);

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 20,
        });

        doc.save("Member_History.pdf");
    };

    const exportToCSV = () => {
        if (historyData.length === 0) {
            alert("No data to export!");
            return;
        }

        const header = ["Date,First Name,Last Name,Mobile No,Email ID,Address,Edited By"];
        const rows = historyData.map(entry =>
            `${formatDate(entry.timestamp)},"${entry.first_name}","${entry.last_name}","${entry.mobile_no}","${entry.email}","${entry.present_address}, ${entry.present_city}, ${entry.present_state} - ${entry.present_pincode}","${entry.edited_by}"`
        );

        const csvContent = [header, ...rows].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "Member_History.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(
            historyData.map(entry => ({
                Date: formatDateTime(entry.timestamp),
                "First Name": entry.first_name,
                "Last Name": entry.last_name,
                "Mobile No": entry.mobile_no,
                "Email ID": entry.email,
                Address: `${entry.present_address}, ${entry.present_city}, ${entry.present_state} - ${entry.present_pincode}`,
                "Edited By": entry.edited_by
            }))
        );
    
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Member History");
        XLSX.writeFile(workbook, "member_history.xlsx");
    };

    const fetchTest = async (mobile) => {
    try {
        const response = await axios.get(`${baseurl}/admin/candidatedetail/${mobile}`);
        const data = response.data;

        if (!data) return;

        const testDate = data.tests?.[0]?.testDate || '';

        setFormData((prev) => ({
        ...prev,
        testDate,
        firstTestName: testDate ? (data.tests?.[0]?.testName || '') : '',
        firstTestScore: data.tests?.[0]?.firsttestScore || '',
        secondTestName: testDate ? (data.tests?.[0]?.secondtestName || '') : '',
        secondTestScore: data.tests?.[0]?.secondtestScore || '',
        }));

    } catch (error) {
        // HANDLE 404 HERE
        if (error.response?.status === 404) {
        console.log("Member test data not found");

        // Optional: clear form
        setFormData((prev) => ({
            ...prev,
            testDate: '',
            firstTestName: '',
            firstTestScore: '',
            secondTestName: '',
            secondTestScore: '',
        }));

        } else {
        console.error("Error fetching test details:", error);
        }
    }
    };

    useEffect(() => {
    // Only recalculate when user is actively editing
    if (!isEditing) return;
    if (!userChangedTermOrDate.current) return;
    
    if (formData.joiningDate && formData.membersTerm && options.length > 0) {
        const joinDate = new Date(formData.joiningDate);
        const month = joinDate.getMonth() + 1;
        const year = joinDate.getFullYear();

        let baseExpiryYear;

        if (month >= 4 && month <= 9) {
        baseExpiryYear = year + 1;
        } else if (month >= 1 && month <= 3) {
        baseExpiryYear = year + 1;
        } else if (month >= 10 && month <= 12) {
        baseExpiryYear = year + 2;
        }

        let expiryYear = baseExpiryYear;

        if (formData.membersTerm === '2' || formData.membersTerm === 2) {
        expiryYear = baseExpiryYear + 4;
        } else if (formData.membersTerm === '3' || formData.membersTerm === 3) {
        expiryYear = baseExpiryYear;
        } else if (formData.membersTerm === '1' || formData.membersTerm === 1) {
            setFormData((prev) => ({
                ...prev,
                expiryDate: "2125-03-31",
            }));
            userChangedTermOrDate.current = false; //Reset after use
            return;
        }

        // Format as YYYY-MM-DD string
        const formattedExpiry = `${expiryYear}-03-31`;

        setFormData((prev) => ({
        ...prev,
        expiryDate: formattedExpiry,
        }));

        userChangedTermOrDate.current = false;
    }
    }, [formData.joiningDate, formData.membersTerm, options, isEditing]); // Add isEditing

    useEffect(() => {

        if (memberId) {
            // Define the API call function
            const fetchMemberDetails = async () => {
                try {
                    const response = await axios.get(`${baseurl}/admin/membersdetail/${memberId}`);
                    const memberData = response.data;
                    // Extract date parts and format them correctly

                    setFormData({
                        firstName: memberData.first_name || '',
                        lastName: memberData.last_name || '',
                        gender: memberData.gender || '',
                        dob: formatDate(memberData.dob) || '',
                        mobileNumber: memberData.mobile_no || '',
                        email: memberData.email || '',
                        joiningDate: formatDate(memberData.date_joining) || '',
                        expiryDate: formatDate(memberData.membership_exp_date) || '',
                        lastRenewal: formatDate(memberData.last_renewal_date) || '',
                        membersTerm: memberData.member_status_id || '',
                        presentAddress: {
                            address: memberData.present_address || '',
                            city: memberData.present_city || '',
                            state: memberData.present_state || '',
                            pincode: memberData.present_pincode || '',
                        },
                        permanentAddress: {
                            address: memberData.permanent_address || '',
                            city: memberData.permanent_city || '',
                            state: memberData.permanent_state || '',
                            pincode: memberData.permanent_pincode || '',
                        },
                        sameAsPresent: memberData.same_address || false,
                        testDate: formatDate(memberData.test_date) || '',
                        // firstTestScore: memberData.first_test_score || '',
                        // firstTestName: memberData.first_test_name || '',
                        // secondTestScore: memberData.second_test_score || '',
                        // secondTestName: memberData.second_test_name || '',
                        note: memberData.note || '',
                        chapterId: memberData.chapter_id || '',
                        chapter_id: memberData.chapter_id || '', //  auto-select if exists
                        cstatus: memberData.cstatus || '',
                        membership_no: memberData.membership_no || '',
                        
                    });
                      // Properly setting profile picture
                    setProfilePic(memberData.profile_pic || defaultImage );
                    setSameAsPresent(memberData.same_address || false);
                    setChapterID(memberData.chapter_id || '');
                    if (memberData.mobile_no) {
                        fetchTest(memberData.mobile_no);
                    }
                    console.log('memberrdata:', memberData)
                } catch (error) {
                    console.error('Error fetching member details:', error);
                }
            };
            fetchMemberDetails();
            fetchHistory();
            fetchTrans();
            fetchOptions();
            
        }

    }, [joiningDate, membersTerm, memberId]);

    
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setProfilePicFile(file); // Store the file directly for FormData
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfilePic(reader.result); // For displaying the image
            };
            reader.readAsDataURL(file);
        }
    };


    const handleEditClick = () => {
        document.getElementById('fileInput').click();
    };

    const initialAddress = {
        address: '',
        city: '',
        state: '',
        pincode: ''
    };

    const [presentAddress, setPresentAddress] = useState({ ...initialAddress });
    const [permanentAddress, setPermanentAddress] = useState({ ...initialAddress });
    
    const [error, setError] = useState('');

    const handleAddressChange = async (e, type) => {
        const { id, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [type]: {
                ...prevData[type],
                [id]: value
            }
        }));
        
    };

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setSameAsPresent(isChecked);
        if (isChecked) {
            setFormData(prevData => ({
                ...prevData,
                permanentAddress: { ...prevData.presentAddress }
            }));
        } else {
            setFormData(prevData => ({
                ...prevData,
                permanentAddress: {
                    address: '',
                    city: '',
                    state: '',
                    pincode: ''
                }
            }));
        }
    };

    const handleEditMode = () => {
        userChangedTermOrDate.current = false;
        originalSnapshot.current = {
            formData: JSON.parse(JSON.stringify(formData)), // deep clone
            sameAsPresent: sameAsPresent,
            profilePic: profilePic,
        };
        setHasChanges(false);
        setIsEditing(true);
    };

    useEffect(() => {
        if (!isEditing || !originalSnapshot.current) return;

        const snap = originalSnapshot.current;
        const formChanged =
            JSON.stringify(formData) !== JSON.stringify(snap.formData);
        const sameChanged = sameAsPresent !== snap.sameAsPresent;
        const picChanged  = profilePic !== snap.profilePic;

        setHasChanges(formChanged || sameChanged || picChanged);
    }, [formData, sameAsPresent, profilePic, isEditing]);

    const fetchHistory = async () => {
        try {
            const response = await axios.get(`${baseurl}/admin/member_history/${memberId}`);
            setHistoryData(response.data); // Correctly set the fetched data to the state
            console.log('history:', response.data);
        } catch (error) {
            console.error('Error fetching member history:', error);
        }
    };
    const fetchOptions = async () => {
        try {
            const response = await axios.get(`${baseurl}/admin/members/memberterms`);
            setOptions(response.data); // Store API data in 'options'
                // console.log("terms:", response.data);
        } catch (error) {
             console.error("Error fetching membership terms:", error);
        }
    };
    const fetchTrans = async () => {
        try {
            const response = await axios.get(`${baseurl}/admin/member_transaction/${memberId}`);
            setTransData(response.data); // Correctly set the fetched data to the state
            console.log('Transaction:', response.data);
        } catch (error) {
            console.error('Error fetching member history:', error);
        }
    };
    const handleSave = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append("firstName", formData.firstName);
        formDataToSend.append("lastName", formData.lastName);
        formDataToSend.append("gender", formData.gender);
        if (formData.dob) {
        formDataToSend.append("dob", formData.dob);
        }
        formDataToSend.append("mobileNumber", formData.mobileNumber);
        formDataToSend.append("membership_no", formData.membership_no);
        formDataToSend.append("chapter_id", formData.chapter_id);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("presentAddress", JSON.stringify(formData.presentAddress));
        formDataToSend.append("permanentAddress", JSON.stringify(formData.permanentAddress));
        formDataToSend.append('sameAsPresent', sameAsPresent || false);
        if (formData.joiningDate) {
        formDataToSend.append("joiningdate", formData.joiningDate);
        }
        if (formData.expiryDate) {
        formDataToSend.append("expiryDate", formData.expiryDate);
        }
        if (formData.lastRenewal) {
        formDataToSend.append("lastrenewal", formData.lastRenewal);
        }
        formDataToSend.append("membersTerm", formData.membersTerm);
        if (formData.testDate) {
            formDataToSend.append("testDate", formData.testDate);
        }
        formDataToSend.append("firstTestName", formData.firstTestName);
        formDataToSend.append("firstTestScore", formData.firstTestScore);
        formDataToSend.append("secondTestName", formData.secondTestName);
        formDataToSend.append("secondTestScore", formData.secondTestScore);
        formDataToSend.append("note", formData.note);
        formDataToSend.append("editedBy", username);
        // Append the profile image if selected
        if (profilePicFile) {
            formDataToSend.append("profilePic", profilePicFile); // Make sure the backend expects "profilePic"
        }
        console.log('updatedata:',formDataToSend);
        try {
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${baseurl}/admin/members/${memberId}`, {
                method: 'PUT', // Use PUT for updating the resource
                headers: {
                    'Authorization': `${token}`,
                },
                body: formDataToSend, // Convert the formData state to a JSON string
            });
            if (response.ok) {
                const result = await response.json();
                console.log('Update successful:', result);
                setIsEditing(false); // Exit edit mode
                setProfilePicFile(null);
                fetchHistory();
            } else if (response.status === 404) {
                console.error('Member not found. Update failed:', response.statusText);
                // Handle not found (e.g., show a specific error message)
                alert('Member not found. Update failed.');
            } else if (response.status === 409) {
                const errorData = await response.json();
                console.error('Conflict error:', errorData.message);
                alert(errorData.message); // "Membership number already exists for another member"
            } else {
                const errorData = await response.json();
                console.error('Update failed:', errorData.message || response.statusText);
                alert(errorData.message || 'Update failed. Please try again.');
            }
        } catch (error) {
            console.error('Error during update:', error);
            // Handle errors (e.g., show an error message)
        }
    };


    const handleClose = () => {
        userChangedTermOrDate.current = false; 
        setIsEditing(false);
        setHasChanges(false);
        originalSnapshot.current = null;
    };

    const [selectedValue, setSelectedValue] = useState('');

    const handleChange = (e) => {
    const { id, value } = e.target;

    // Mark that user manually changed these fields
    if (id === 'joiningDate' || id === 'membersTerm') {
        userChangedTermOrDate.current = true;
    }

    setFormData(prevData => ({
        ...prevData,
        [id]: value
    }));
};

    const formatDateTime = (timestamp) => {
    if (!timestamp) return '';

    const date = new Date(timestamp);

    const datePart = date.toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).replace(/\//g, '-'); 

    const timePart = date.toLocaleTimeString('en-IN', {
        timeZone: 'Asia/Kolkata',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    return `${datePart} `;
    };
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);

    const handleDelete = (memberId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You Want Delete Member ${memberId}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${baseurl}/admin/member/${memberId}`, {
          headers: { Authorization: `${token}` }
        })
        .then((res) => {
          Swal.fire('Deleted!', res.data.message || 'Member deleted.', 'success');
          setTimeout(() => {
            navigate("/admin/MemberList"); // Navigate to MemberList page after 5 seconds
          }, 500);
        })
        .catch((err) => {
          Swal.fire('Error!', err.response?.data?.message || 'Delete failed.', 'error');
        });
      }
    });
  };


    return (

        // <div className="page-wrapper">
        <div className="container mt-4">
            <button className="cl-back-btn " onClick={() => navigate("/admin/memberlist")}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10 3L5 8l5 5"/></svg>
                Back
            </button>
            <div className="row mb-3 align-items-center" style={{marginTop:'15px'}}>
                <div className="col-md-6">
                    <h2 style={{marginBottom:'0'}}>Members Details:</h2>
                </div>
                <div className="col-md-6 text-end">
                {(roleid === 1 || String(initialChapter) === String(chapterID)) && !isEditing && (
                    <button
                    onClick={handleEditMode}
                    style={{ color: 'white', borderRadius: '8px' }}
                    >
                    Edit
                    </button>
                )}

                {roleid === 1 && (
                    <button
                    className="btn btn-sm btn-danger delete-member"
                    onClick={() => handleDelete(memberId)}
                    >
                    Delete
                    </button>
                )}
                </div>

            </div>
            <div className="profile-section">
                <div className="row">
                    <div className="col-md-4">
                        <div className="mb-3">
                            <div className="profile-pic">
                                <img src={profilePic} alt="Profile" className="img-fluid" />
                                {isEditing && <i className="fas fa-edit" onClick={handleEditClick}></i>}
                                <input
                                    type="file"
                                    id="fileInput"
                                    style={{ display: 'none' }}
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="tel" className="form-control" id="membership_no" placeholder="Membership No" value={formData.membership_no} onChange={handleChange} disabled={!isEditing} />
                            <label htmlFor="membership_no"><i className="bi bi-person form-icon"></i> Membership No</label>
                        </div>
                    </div>
                    {/* ✅ Chapter Select */}
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <select
                                className="form-select"
                                id="chapter_id"
                                name="chapter_id"
                                value={formData.chapter_id || ''}
                                onChange={handleChange}
                                disabled={!isEditing}
                            >
                                <option value="">-- Select Chapter --</option>
                                {chapters.map((chapter) => (
                                    <option key={chapter.chapter_id} value={chapter.chapter_id}>
                                        {chapter.chapter_name}
                                    </option>
                                ))}
                            </select>
                            <label htmlFor="chapter_id">
                                <i className="bi bi-journal form-icon"></i> Chapter
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input type="text" className="form-control" id="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} disabled={!isEditing} />
                                    <label htmlFor="firstName"><i className="bi bi-person form-icon"></i> First Name</label>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input type="text" className="form-control" id="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} disabled={!isEditing} />
                                    <label htmlFor="lastName"><i className="bi bi-person form-icon"></i> Last Name</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <select className="form-select" id="gender" placeholder="Gender" value={formData.gender} onChange={handleChange} disabled={!isEditing}>
                                        <option value="" disabled>Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </select>
                                    <label htmlFor="gender"><i className="bi bi-gender-ambiguous form-icon"></i> Gender</label>
                                </div>
                            </div>
                        </div>
                        <div className="row">

                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input type="date" className="form-control" id="dob" placeholder="Date of Birth" value={formData.dob} onChange={handleChange} disabled={!isEditing} />
                                    <label htmlFor="dob"><i className="bi bi-calendar form-icon"></i> Date of Birth</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input type="tel" className="form-control" id="mobileNumber" placeholder="Mobile Number" value={formData.mobileNumber} onChange={handleChange} disabled={!isEditing} />
                                    <label htmlFor="mobileNumber"><i className="bi bi-telephone form-icon"></i> Mobile Number</label>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input type="email" className="form-control" id="email" placeholder="Email" value={formData.email} onChange={handleChange} disabled={!isEditing} />
                                    <label htmlFor="email"><i className="bi bi-envelope form-icon"></i> Email</label>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div className='row' style={{ top: '40px', position: 'relative' }}>
                    <div className="col-md-6">
                        <div>
                            <h3>Present Address:</h3>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="address"
                                    placeholder="Address"
                                    value={formData.presentAddress.address}
                                    onChange={e => handleAddressChange(e, 'presentAddress')}
                                    disabled={!isEditing}
                                />
                                <label htmlFor="address"><i className="bi bi-house-fill form-icon"></i> Address</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="pincode"
                                    placeholder="Pincode"
                                    value={formData.presentAddress.pincode}
                                    onChange={e => handleAddressChange(e, 'presentAddress')}
                                    disabled={!isEditing}
                                />
                                <label htmlFor="pincode"><i className="bi bi-mailbox form-icon"></i> Pincode</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    placeholder="City"
                                    value={formData.presentAddress.city}
                                    onChange={e => handleAddressChange(e, 'presentAddress')}
                                    disabled={!isEditing}
                                // readOnly // City field is automatically filled based on pincode
                                />
                                <label htmlFor="city"><i className="bi bi-building-fill form-icon"></i> City</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="state"
                                    placeholder="State"
                                    value={formData.presentAddress.state}
                                    onChange={e => handleAddressChange(e, 'presentAddress')}
                                    disabled={!isEditing}
                                // readOnly // State field is automatically filled based on pincode
                                />
                                <label htmlFor="state"><i className="bi bi-geo-alt-fill form-icon"></i> State</label>
                            </div>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sameAsPresent"
                                    value={formData.sameAsPresent}
                                    checked={sameAsPresent}
                                    onChange={handleCheckboxChange}
                                    disabled={!isEditing}
                                />
                                <label className="form-check-label" htmlFor="sameAsPresent">
                                    Permanent Address Same as Present
                                </label>
                            </div>
                            {error && <p className="text-danger">{error}</p>}
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div>
                            <h3>Permanent Address:</h3>

                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="address"
                                    placeholder="Address"
                                    value={formData.permanentAddress.address}
                                    onChange={e => handleAddressChange(e, 'permanentAddress')}
                                    disabled={sameAsPresent || !isEditing}
                                />
                                <label htmlFor="address"><i className="bi bi-house-fill form-icon"></i> Address</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="pincode"
                                    placeholder="Pincode"
                                    value={formData.permanentAddress.pincode}
                                    onChange={e => handleAddressChange(e, 'permanentAddress')}
                                    disabled={sameAsPresent || !isEditing}

                                />
                                <label htmlFor="pincode"><i className="bi bi-mailbox form-icon"></i> Pincode</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    placeholder="City"
                                    value={formData.permanentAddress.city}
                                    onChange={e => handleAddressChange(e, 'permanentAddress')}
                                    disabled={sameAsPresent || !isEditing}
                                />
                                <label htmlFor="city"><i className="bi bi-building-fill form-icon"></i> City</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="state"
                                    placeholder="State"
                                    value={formData.permanentAddress.state}
                                    onChange={e => handleAddressChange(e, 'permanentAddress')}
                                    disabled={sameAsPresent || !isEditing}
                                />
                                <label htmlFor="state"><i className="bi bi-geo-alt-fill form-icon"></i> State</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row' style={{ top: '40px', position: 'relative' }}>
                    <h3>Members Details:</h3>

                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="joiningDate"
                                placeholder="Joining Date"
                                value={formData.joiningDate}
                                onChange={handleChange}
                                disabled={!isEditing}
                            />
                            <label htmlFor="joiningDate"><i className="bi bi-calendar"></i> Joining Date</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="expiryDate"
                                placeholder="Expiry Date"
                                onChange={handleChange}
                                value={formData.expiryDate || ''}
                                disabled={!isEditing}
                            />
                            <label htmlFor="expiryDate"><i className="bi bi-calendar-check"></i> Expiry Date</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="lastRenewal"
                                placeholder="Last Renewal"
                                value={formData.lastRenewal || lastRenewal}
                                onChange={handleChange} 
                                disabled={!isEditing}
                            />
                            <label htmlFor="lastRenewal"><i className="bi bi-calendar-check form-icon"></i> Last Renewal</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <select
                            className="form-select"
                            id="membersTerm"
                            value={formData.membersTerm} // bound to DB + user updates
                            onChange={handleChange}
                            aria-label="Member's Term"
                            style={{ borderRadius: "20px" }}
                            disabled={!isEditing}
                            >
                            <option value="" disabled>Select Term</option>
                            {options.map((term) => (
                                <option key={term.member_status_id} value={term.member_status_id}>
                                {term.status_name}
                                </option>
                            ))}
                            </select>

                            <label htmlFor="membersTerm">
                                <i className="bi bi-file-earmark-person form-icon"></i> Member's Term
                            </label>
                        </div>
                    </div>
                </div>


                <div className="row" style={{ top: '80px', position: 'relative' }}>
                    <h3>Test Details:</h3>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="date" className="form-control" id="testDate" placeholder="Test Date"  value={formData.testDate} onChange={handleChange} disabled={!isEditing} />
                            <label htmlFor="testDate"><i className="bi bi-calendar"></i> Test Date</label>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="text" className="form-control" id="firstTestScore" placeholder="First Test Score"  value={formData.firstTestScore} onChange={handleChange} disabled={!isEditing} />
                            <label htmlFor="firstTestScore"><i className="bi bi-clipboard-check"></i> First Test Score</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="text" className="form-control" id="firstTestName" placeholder="First Test Name" value={formData.firstTestName} onChange={handleChange} disabled={!isEditing} />
                            <label htmlFor="firstTestName"><i className="bi bi-file-earmark-text"></i> First Test Name</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="text" className="form-control" id="secondTestScore" placeholder="Second Test Score" value={formData.secondTestScore} onChange={handleChange} disabled={!isEditing} />
                            <label htmlFor="secondTestScore"><i className="bi bi-clipboard-check"></i> Second Test Score</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="text" className="form-control" id="secondTestName" placeholder="Second Test Name"  value={formData.secondTestName} onChange={handleChange} disabled={!isEditing} />
                            <label htmlFor="secondTestName"><i className="bi bi-file-earmark-text"></i> Second Test Name</label>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-12 form-floating">
                            <textarea className="form-control" id="note" placeholder="Note" rows="4"  value={formData.note} onChange={handleChange} disabled={!isEditing}></textarea>
                            <label htmlFor="note"><i className="bi bi-sticky form-icon"></i> Note</label>
                        </div>
                    </div>

                </div>
                {isEditing && (
                    <div className="text-center" style={{ top: '90px', position: 'relative' }}>
                        <button className="btn btn-danger" onClick={handleClose}>Cancel</button>&nbsp;&nbsp;
                        <button
                            style={{ borderRadius: '8px' }}
                            onClick={handleSave}
                            disabled={!hasChanges}          // ← add this
                        >
                            Save
                        </button>
                    </div>
                )}

                <div className="container">
                    <div className="row py-5">
                        <h3 style={{ paddingTop: '50px' }}>History Details:</h3>

                        {historyData.length > 0 ? (
                            <>
                                {/* Export Buttons */}
                                <div className="mb-3">
                                    <button className="btn btn-primary me-2" onClick={exportToCSV}>Export to CSV</button>
                                    <button className="btn btn-danger me-2" onClick={exportToPDF}>Export to PDF</button>
                                    <button className="btn btn-success" onClick={exportToExcel}>Export to Excel</button>
                                </div>

                                {/* Table */}
                                <div className="col-12" style={{ maxHeight: '300px', overflow: 'auto' }}>
                                    <table id="example" className="table table-hover responsive nowrap" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Sr.No</th>
                                                <th>Membership No</th>
                                                <th>Chapter ID</th>
                                                <th>Name</th>
                                                <th>Photo</th>
                                                <th>Mobile No:</th>
                                                <th>Email ID</th>
                                                <th>Present Address</th>
                                                <th>Permanent Address</th>
                                                <th>Date</th>
                                                <th>First Test Name</th>
                                                <th>First Test Score</th>
                                                <th>Second Test Name</th>
                                                <th>Second Test Score</th>
                                                <th>Date of Joining</th>
                                                <th>Vaild till</th>
                                                <th>Last Renewal Date</th>
                                                <th>Edited By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
  {historyData.map((entry, index) => {

    //  Compare every history row against current formData (the latest saved record)
    const norm = (val) => String(val ?? '').trim().toLowerCase();
    const diff = (histVal, currVal) => norm(histVal) !== norm(currVal);

    // Build address strings for both history entry and current formData
    const presentAddr   = `${entry.present_address}, ${entry.present_city}, ${entry.present_state} - ${entry.present_pincode}`;
    const permanentAddr = `${entry.permanent_address}, ${entry.permanent_city}, ${entry.permanent_state} - ${entry.permanent_pincode}`;

    const presentAddrChanged =
      diff(entry.present_address, formData.presentAddress.address) ||
      diff(entry.present_city,    formData.presentAddress.city)    ||
      diff(entry.present_state,   formData.presentAddress.state)   ||
      diff(entry.present_pincode, formData.presentAddress.pincode);

    const permanentAddrChanged =
      diff(entry.permanent_address, formData.permanentAddress.address) ||
      diff(entry.permanent_city,    formData.permanentAddress.city)    ||
      diff(entry.permanent_state,   formData.permanentAddress.state)   ||
      diff(entry.permanent_pincode, formData.permanentAddress.pincode);

    // Helper: returns changedCellStyle if history value differs from current formData value
    const hi = (histVal, currVal) => diff(histVal, currVal) ? changedCellStyle : {};

    // Count total changed fields for the badge
    const changedCount = [
      diff(entry.membership_no,       formData.membership_no),
      diff(entry.chapter_id,          formData.chapter_id),
      diff(entry.first_name,          formData.firstName),
      diff(entry.last_name,           formData.lastName),
      diff(entry.mobile_no,           formData.mobileNumber),
      diff(entry.email,               formData.email),
      presentAddrChanged,
      permanentAddrChanged,
      diff(entry.first_test_name,     formData.firstTestName),
      diff(entry.first_test_score,    formData.firstTestScore),
      diff(entry.second_test_name,    formData.secondTestName),
      diff(entry.second_test_score,   formData.secondTestScore),
      diff(entry.date_joining,        formData.joiningDate),
      diff(entry.membership_exp_date, formData.expiryDate),
      diff(entry.last_renewal_date,   formData.lastRenewal),
    ].filter(Boolean).length;

    return (
      <tr key={index}>

        {/* Sr.No + diff badge */}
        <td>
          {index + 1}
          {changedCount > 0 && (
            <span style={{
              marginLeft: 6, fontSize: 10,
              background: '#fff5f5', color: '#c0392b',
              border: '1px solid #f09595',
              borderRadius: 3, padding: '1px 5px',
              whiteSpace: 'nowrap'
            }}>
              {changedCount} diff
            </span>
          )}
        </td>

        <td style={hi(entry.membership_no, formData.membership_no)}>
          {entry.membership_no}
        </td>

        <td style={hi(entry.chapter_id, formData.chapter_id)}>
          {entry.chapter_id}
        </td>

        <td style={(diff(entry.first_name, formData.firstName) || diff(entry.last_name, formData.lastName)) ? changedCellStyle : {}}>
          {entry.first_name} {entry.last_name}
        </td>

        <td>
          <img
            src={entry.profile_pic}
            alt="Profile"
            style={{
              width: 50, height: 50,
              borderRadius: '10%', objectFit: 'contain',
              outline: diff(entry.profile_pic, profilePic)
                ? '2px solid #c0392b' : 'none'
            }}
          />
        </td>

        <td style={hi(entry.mobile_no, formData.mobileNumber)}>
          {entry.mobile_no}
        </td>

        <td style={hi(entry.email, formData.email)}>
          {entry.email}
        </td>

        <td style={presentAddrChanged ? changedCellStyle : {}}>
          {presentAddr}
        </td>

        <td style={permanentAddrChanged ? changedCellStyle : {}}>
          {permanentAddr}
        </td>

        {/* Date — audit timestamp, never highlighted */}
        <td>{formatDateTime(entry.timestamp)}</td>

        <td style={hi(entry.first_test_name, formData.firstTestName)}>
          {entry.first_test_name || '—'}
        </td>

        <td style={hi(entry.first_test_score, formData.firstTestScore)}>
          {entry.first_test_score || '—'}
        </td>

        <td style={hi(entry.second_test_name, formData.secondTestName)}>
          {entry.second_test_name || '—'}
        </td>

        <td style={hi(entry.second_test_score, formData.secondTestScore)}>
          {entry.second_test_score || '—'}
        </td>

        <td style={hi(formatDateTime(entry.date_joining), formatDateTime(formData.joiningDate))}>
          {formatDateTime(entry.date_joining)}
        </td>

        <td style={hi(formatDateTime(entry.membership_exp_date), formatDateTime(formData.expiryDate))}>
          {formatDateTime(entry.membership_exp_date)}
        </td>

        <td style={hi(formatDateTime(entry.last_renewal_date), formatDateTime(formData.lastRenewal))}>
          {formatDateTime(entry.last_renewal_date)}
        </td>

        {/* Edited by — audit field, never highlighted */}
        <td>{entry.edited_by}</td>

      </tr>
    );
  })}
</tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            <h3 style={{ textAlign: 'center', color: 'red' }}>No Data Found</h3>
                        )}
                    </div>
                </div>


                <div className="container">
                    <div className="row">
                        <h3>Transaction Details:</h3>
                        <div className="col-12">
                            <table id="example1" className="table table-hover responsive nowrap" style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>Transaction ID</th>
                                        <th>Test Fees</th>
                                        <th>Payment Method</th>
                                        <th>Transaction Date</th>
                                        {/* <th>Transaction Type</th>
            <th>Automatic Renewal</th> */}

                                    </tr>
                                </thead>
                                <tbody>
                                    {transData.map((trans, index) => (
                                                <tr key={index}>
                                                    <td>{trans.payment_no}</td>
                                                    <td>{trans.amount}</td>
                                                    <td>{trans.payment_method}</td>
                                                    <td>{formatDateTime(trans.trans_datetime)}</td>
                                                </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        // </div>

    );
};

export default MemberForm;
